'use client';

import classNames from 'classnames';
import { IconShoppingCart } from '@/features/icons';
import { MAXIMUM_ADD_TO_CART_COUNTER_SHOW_LIMIT } from '@/app/(pdp)/constants';
import useGetCartCount from '@/app/_utils/use-cart-count';
function CartCounterButton() {
  const {
    cartCount
  } = useGetCartCount();
  return <div className='relative' data-sentry-component="CartCounterButton" data-sentry-source-file="cart-counter-button.tsx">
            {!!cartCount && <span className={classNames('absolute -right-1 top-3 flex h-3.5 w-3.5 items-center justify-center rounded bg-brand-secondary text-center text-[8px] font-bold text-white')}>
                    {cartCount > MAXIMUM_ADD_TO_CART_COUNTER_SHOW_LIMIT ? `${MAXIMUM_ADD_TO_CART_COUNTER_SHOW_LIMIT}+` : cartCount}
                </span>}
            <IconShoppingCart className='h-6 w-6 text-text-black' data-sentry-element="IconShoppingCart" data-sentry-source-file="cart-counter-button.tsx" />
        </div>;
}
export default CartCounterButton;